import Contactform from '../../components/contactus/contactform';
import Contactusmap from '../../components/contactus/contactusmap';
import Head from 'next/head';
import ContactUs from '../../components/contactus/contactus';
import Contactpage from '@/components/contactus/contactpage';
import { useEffect } from 'react';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';

export default function Contactus() {

  useEffect(() => {
    handleGestLogUserData();

  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"Contact Us"
      }
      
      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Head>
      <title>Online Campus Placement | Virtual Campus Recruitment Portal</title>
      <meta property="og:type" content="website"/>
      <meta name="description" content={"Streamline virtual campus hiring with easycampus virtual campus recruitment portal to save time, save energy, save cost, and gain valuable insights for valuable decisions."}/>
      <meta property="og:title" content={"Streamline virtual campus hiring with easycampus virtual campus recruitment portal to save time, save energy, save cost, and gain valuable insights for valuable decisions."}/>
      <meta name="description" content={"Streamline virtual campus hiring with easycampus virtual campus recruitment portal to save time, save energy, save cost, and gain valuable insights for valuable decisions."}/>
      <meta name="keywords" content={"Easycampus"}/>
      <meta property="og:url" content={"www.easycampus.in"}/>
      <meta property="og:description" content={"Streamline virtual campus hiring with easycampus virtual campus recruitment portal to save time, save energy, save cost, and gain valuable insights for valuable decisions."}/>
      <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'}/>
    </Head> 
      <main className="flex min-h-screen flex-col">
          <div className="w-full mx-auto z-10">
           <Contactpage/>
           <Contactform/>
           <ContactUs/>
           <Contactusmap/>
          </div>
        </main>
    </>
  );
}
